/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoadingCapabilitiesAvailability } from './LoadingCapabilitiesAvailability';
import {
    LoadingCapabilitiesAvailabilityFromJSON,
    LoadingCapabilitiesAvailabilityFromJSONTyped,
    LoadingCapabilitiesAvailabilityToJSON,
    LoadingCapabilitiesAvailabilityToJSONTyped,
} from './LoadingCapabilitiesAvailability';
import type { Quote } from './Quote';
import {
    QuoteFromJSON,
    QuoteFromJSONTyped,
    QuoteToJSON,
    QuoteToJSONTyped,
} from './Quote';
import type { ShipmentState } from './ShipmentState';
import {
    ShipmentStateFromJSON,
    ShipmentStateFromJSONTyped,
    ShipmentStateToJSON,
    ShipmentStateToJSONTyped,
} from './ShipmentState';
import type { Broker } from './Broker';
import {
    BrokerFromJSON,
    BrokerFromJSONTyped,
    BrokerToJSON,
    BrokerToJSONTyped,
} from './Broker';
import type { StateOfGoods } from './StateOfGoods';
import {
    StateOfGoodsFromJSON,
    StateOfGoodsFromJSONTyped,
    StateOfGoodsToJSON,
    StateOfGoodsToJSONTyped,
} from './StateOfGoods';
import type { EmergencyContactDetails } from './EmergencyContactDetails';
import {
    EmergencyContactDetailsFromJSON,
    EmergencyContactDetailsFromJSONTyped,
    EmergencyContactDetailsToJSON,
    EmergencyContactDetailsToJSONTyped,
} from './EmergencyContactDetails';
import type { PreQuoteLocation } from './PreQuoteLocation';
import {
    PreQuoteLocationFromJSON,
    PreQuoteLocationFromJSONTyped,
    PreQuoteLocationToJSON,
    PreQuoteLocationToJSONTyped,
} from './PreQuoteLocation';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { LineItem } from './LineItem';
import {
    LineItemFromJSON,
    LineItemFromJSONTyped,
    LineItemToJSON,
    LineItemToJSONTyped,
} from './LineItem';
import type { BookingSuspendedReason } from './BookingSuspendedReason';
import {
    BookingSuspendedReasonFromJSON,
    BookingSuspendedReasonFromJSONTyped,
    BookingSuspendedReasonToJSON,
    BookingSuspendedReasonToJSONTyped,
} from './BookingSuspendedReason';
import type { EquipmentType } from './EquipmentType';
import {
    EquipmentTypeFromJSON,
    EquipmentTypeFromJSONTyped,
    EquipmentTypeToJSON,
    EquipmentTypeToJSONTyped,
} from './EquipmentType';
import type { Contact } from './Contact';
import {
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
    ContactToJSONTyped,
} from './Contact';

/**
 * 
 * @export
 * @interface PreBookingShipment
 */
export interface PreBookingShipment {
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    shipmentId: string;
    /**
     * 
     * @type {Quote}
     * @memberof PreBookingShipment
     */
    selectedQuote?: Quote;
    /**
     * 
     * @type {Array<LineItem>}
     * @memberof PreBookingShipment
     */
    lineItems: Array<LineItem>;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    pickupDate: string;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    pickupDeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    deliveryDeadline?: string;
    /**
     * 
     * @type {EquipmentType}
     * @memberof PreBookingShipment
     */
    equipmentType?: EquipmentType;
    /**
     * 
     * @type {PreQuoteLocation}
     * @memberof PreBookingShipment
     */
    pickupLocation: PreQuoteLocation;
    /**
     * 
     * @type {PreQuoteLocation}
     * @memberof PreBookingShipment
     */
    deliveryLocation: PreQuoteLocation;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    pickupReferenceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    deliveryReferenceNumber: string;
    /**
     * Amazon Reference ID, unpacked server-side from deliveryReferenceNumber. Only present when the delivery is to an Amazon distribution warehouse
     * @type {string}
     * @memberof PreBookingShipment
     */
    deliveryAmazonReferenceId?: string;
    /**
     * Amazon Shipment ID, unpacked server-side from deliveryReferenceNumber. Only present when the delivery is to an Amazon distribution warehouse
     * @type {string}
     * @memberof PreBookingShipment
     */
    deliveryAmazonShipmentId?: string;
    /**
     * 
     * @type {Contact}
     * @memberof PreBookingShipment
     */
    pickupContact?: Contact;
    /**
     * 
     * @type {Contact}
     * @memberof PreBookingShipment
     */
    deliveryContact?: Contact;
    /**
     * Extra email addresses that receive a notification when this shipment is booked, in addition to the delivery contact.
     * @type {Array<string>}
     * @memberof PreBookingShipment
     */
    additionalNotificationEmails?: Array<string> | null;
    /**
     * 
     * @type {Broker}
     * @memberof PreBookingShipment
     */
    broker?: Broker;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    stripePaymentMethodId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PreBookingShipment
     */
    isReviewingPriorToBookingShipment: boolean;
    /**
     * 
     * @type {Quote}
     * @memberof PreBookingShipment
     */
    cheapestQuote?: Quote;
    /**
     * 
     * @type {ShipmentState}
     * @memberof PreBookingShipment
     */
    shipmentState: ShipmentState;
    /**
     * 
     * @type {EmergencyContactDetails}
     * @memberof PreBookingShipment
     */
    emergencyContactDetails?: EmergencyContactDetails;
    /**
     * 
     * @type {Array<string>}
     * @memberof PreBookingShipment
     */
    finalizeBookingStages: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PreBookingShipment
     */
    manualQuotingOpen: boolean;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    manualQuotingNotes: string;
    /**
     * 
     * @type {number}
     * @memberof PreBookingShipment
     */
    paymentTermsDays: number;
    /**
     * 
     * @type {boolean}
     * @memberof PreBookingShipment
     */
    isBookingSuspended: boolean;
    /**
     * 
     * @type {BookingSuspendedReason}
     * @memberof PreBookingShipment
     */
    bookingSuspendedReason: BookingSuspendedReason;
    /**
     * 
     * @type {boolean}
     * @memberof PreBookingShipment
     */
    addInsuranceToShipment: boolean;
    /**
     * 
     * @type {number}
     * @memberof PreBookingShipment
     */
    insuranceAmount: number;
    /**
     * 
     * @type {Currency}
     * @memberof PreBookingShipment
     */
    insuranceCurrency: Currency;
    /**
     * 
     * @type {number}
     * @memberof PreBookingShipment
     */
    insurancePremiumAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    insurancePremiumCurrency?: string;
    /**
     * 
     * @type {number}
     * @memberof PreBookingShipment
     */
    insurancePremiumTaxesAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    insurancePremiumReferralReason?: string;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    insuranceCommodityGroup?: string;
    /**
     * 
     * @type {StateOfGoods}
     * @memberof PreBookingShipment
     */
    stateOfGoods: StateOfGoods;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    branchId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    quotedBy: string;
    /**
     * 
     * @type {number}
     * @memberof PreBookingShipment
     */
    linearFeet?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PreBookingShipment
     */
    exclusiveUseNeeded: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreBookingShipment
     */
    tarpRequired: boolean;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    pickupBoothNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PreBookingShipment
     */
    deliveryBoothNumber: string;
    /**
     * Bill of lading number for tracking with carriers
     * @type {string}
     * @memberof PreBookingShipment
     */
    billOfLadingNumber?: string | null;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof PreBookingShipment
     */
    pickupLocationHasDock: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof PreBookingShipment
     */
    pickupLocationHasForklift: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof PreBookingShipment
     */
    deliveryLocationHasDock: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof PreBookingShipment
     */
    deliveryLocationHasForklift: LoadingCapabilitiesAvailability;
}



/**
 * Check if a given object implements the PreBookingShipment interface.
 */
export function instanceOfPreBookingShipment(value: object): value is PreBookingShipment {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('lineItems' in value) || value['lineItems'] === undefined) return false;
    if (!('pickupDate' in value) || value['pickupDate'] === undefined) return false;
    if (!('pickupLocation' in value) || value['pickupLocation'] === undefined) return false;
    if (!('deliveryLocation' in value) || value['deliveryLocation'] === undefined) return false;
    if (!('pickupReferenceNumber' in value) || value['pickupReferenceNumber'] === undefined) return false;
    if (!('deliveryReferenceNumber' in value) || value['deliveryReferenceNumber'] === undefined) return false;
    if (!('isReviewingPriorToBookingShipment' in value) || value['isReviewingPriorToBookingShipment'] === undefined) return false;
    if (!('shipmentState' in value) || value['shipmentState'] === undefined) return false;
    if (!('finalizeBookingStages' in value) || value['finalizeBookingStages'] === undefined) return false;
    if (!('manualQuotingOpen' in value) || value['manualQuotingOpen'] === undefined) return false;
    if (!('manualQuotingNotes' in value) || value['manualQuotingNotes'] === undefined) return false;
    if (!('paymentTermsDays' in value) || value['paymentTermsDays'] === undefined) return false;
    if (!('isBookingSuspended' in value) || value['isBookingSuspended'] === undefined) return false;
    if (!('bookingSuspendedReason' in value) || value['bookingSuspendedReason'] === undefined) return false;
    if (!('addInsuranceToShipment' in value) || value['addInsuranceToShipment'] === undefined) return false;
    if (!('insuranceAmount' in value) || value['insuranceAmount'] === undefined) return false;
    if (!('insuranceCurrency' in value) || value['insuranceCurrency'] === undefined) return false;
    if (!('stateOfGoods' in value) || value['stateOfGoods'] === undefined) return false;
    if (!('quotedBy' in value) || value['quotedBy'] === undefined) return false;
    if (!('exclusiveUseNeeded' in value) || value['exclusiveUseNeeded'] === undefined) return false;
    if (!('tarpRequired' in value) || value['tarpRequired'] === undefined) return false;
    if (!('pickupBoothNumber' in value) || value['pickupBoothNumber'] === undefined) return false;
    if (!('deliveryBoothNumber' in value) || value['deliveryBoothNumber'] === undefined) return false;
    if (!('pickupLocationHasDock' in value) || value['pickupLocationHasDock'] === undefined) return false;
    if (!('pickupLocationHasForklift' in value) || value['pickupLocationHasForklift'] === undefined) return false;
    if (!('deliveryLocationHasDock' in value) || value['deliveryLocationHasDock'] === undefined) return false;
    if (!('deliveryLocationHasForklift' in value) || value['deliveryLocationHasForklift'] === undefined) return false;
    return true;
}

export function PreBookingShipmentFromJSON(json: any): PreBookingShipment {
    return PreBookingShipmentFromJSONTyped(json, false);
}

export function PreBookingShipmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreBookingShipment {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
        'selectedQuote': json['selectedQuote'] == null ? undefined : QuoteFromJSON(json['selectedQuote']),
        'lineItems': ((json['lineItems'] as Array<any>).map(LineItemFromJSON)),
        'pickupDate': json['pickupDate'],
        'pickupDeadline': json['pickupDeadline'] == null ? undefined : json['pickupDeadline'],
        'deliveryDeadline': json['deliveryDeadline'] == null ? undefined : json['deliveryDeadline'],
        'equipmentType': json['equipmentType'] == null ? undefined : EquipmentTypeFromJSON(json['equipmentType']),
        'pickupLocation': PreQuoteLocationFromJSON(json['pickupLocation']),
        'deliveryLocation': PreQuoteLocationFromJSON(json['deliveryLocation']),
        'pickupReferenceNumber': json['pickupReferenceNumber'],
        'deliveryReferenceNumber': json['deliveryReferenceNumber'],
        'deliveryAmazonReferenceId': json['deliveryAmazonReferenceId'] == null ? undefined : json['deliveryAmazonReferenceId'],
        'deliveryAmazonShipmentId': json['deliveryAmazonShipmentId'] == null ? undefined : json['deliveryAmazonShipmentId'],
        'pickupContact': json['pickupContact'] == null ? undefined : ContactFromJSON(json['pickupContact']),
        'deliveryContact': json['deliveryContact'] == null ? undefined : ContactFromJSON(json['deliveryContact']),
        'additionalNotificationEmails': json['additionalNotificationEmails'] == null ? undefined : json['additionalNotificationEmails'],
        'broker': json['broker'] == null ? undefined : BrokerFromJSON(json['broker']),
        'stripePaymentMethodId': json['stripePaymentMethodId'] == null ? undefined : json['stripePaymentMethodId'],
        'isReviewingPriorToBookingShipment': json['isReviewingPriorToBookingShipment'],
        'cheapestQuote': json['cheapestQuote'] == null ? undefined : QuoteFromJSON(json['cheapestQuote']),
        'shipmentState': ShipmentStateFromJSON(json['shipmentState']),
        'emergencyContactDetails': json['emergencyContactDetails'] == null ? undefined : EmergencyContactDetailsFromJSON(json['emergencyContactDetails']),
        'finalizeBookingStages': json['finalizeBookingStages'],
        'manualQuotingOpen': json['manualQuotingOpen'],
        'manualQuotingNotes': json['manualQuotingNotes'],
        'paymentTermsDays': json['paymentTermsDays'],
        'isBookingSuspended': json['isBookingSuspended'],
        'bookingSuspendedReason': BookingSuspendedReasonFromJSON(json['bookingSuspendedReason']),
        'addInsuranceToShipment': json['addInsuranceToShipment'],
        'insuranceAmount': json['insuranceAmount'],
        'insuranceCurrency': CurrencyFromJSON(json['insuranceCurrency']),
        'insurancePremiumAmount': json['insurancePremiumAmount'] == null ? undefined : json['insurancePremiumAmount'],
        'insurancePremiumCurrency': json['insurancePremiumCurrency'] == null ? undefined : json['insurancePremiumCurrency'],
        'insurancePremiumTaxesAmount': json['insurancePremiumTaxesAmount'] == null ? undefined : json['insurancePremiumTaxesAmount'],
        'insurancePremiumReferralReason': json['insurancePremiumReferralReason'] == null ? undefined : json['insurancePremiumReferralReason'],
        'insuranceCommodityGroup': json['insuranceCommodityGroup'] == null ? undefined : json['insuranceCommodityGroup'],
        'stateOfGoods': StateOfGoodsFromJSON(json['stateOfGoods']),
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'quotedBy': json['quotedBy'],
        'linearFeet': json['linearFeet'] == null ? undefined : json['linearFeet'],
        'exclusiveUseNeeded': json['exclusiveUseNeeded'],
        'tarpRequired': json['tarpRequired'],
        'pickupBoothNumber': json['pickupBoothNumber'],
        'deliveryBoothNumber': json['deliveryBoothNumber'],
        'billOfLadingNumber': json['billOfLadingNumber'] == null ? undefined : json['billOfLadingNumber'],
        'pickupLocationHasDock': LoadingCapabilitiesAvailabilityFromJSON(json['pickupLocationHasDock']),
        'pickupLocationHasForklift': LoadingCapabilitiesAvailabilityFromJSON(json['pickupLocationHasForklift']),
        'deliveryLocationHasDock': LoadingCapabilitiesAvailabilityFromJSON(json['deliveryLocationHasDock']),
        'deliveryLocationHasForklift': LoadingCapabilitiesAvailabilityFromJSON(json['deliveryLocationHasForklift']),
    };
}

  export function PreBookingShipmentToJSON(json: any): PreBookingShipment {
      return PreBookingShipmentToJSONTyped(json, false);
  }

  export function PreBookingShipmentToJSONTyped(value?: PreBookingShipment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
        'selectedQuote': QuoteToJSON(value['selectedQuote']),
        'lineItems': ((value['lineItems'] as Array<any>).map(LineItemToJSON)),
        'pickupDate': value['pickupDate'],
        'pickupDeadline': value['pickupDeadline'],
        'deliveryDeadline': value['deliveryDeadline'],
        'equipmentType': EquipmentTypeToJSON(value['equipmentType']),
        'pickupLocation': PreQuoteLocationToJSON(value['pickupLocation']),
        'deliveryLocation': PreQuoteLocationToJSON(value['deliveryLocation']),
        'pickupReferenceNumber': value['pickupReferenceNumber'],
        'deliveryReferenceNumber': value['deliveryReferenceNumber'],
        'deliveryAmazonReferenceId': value['deliveryAmazonReferenceId'],
        'deliveryAmazonShipmentId': value['deliveryAmazonShipmentId'],
        'pickupContact': ContactToJSON(value['pickupContact']),
        'deliveryContact': ContactToJSON(value['deliveryContact']),
        'additionalNotificationEmails': value['additionalNotificationEmails'],
        'broker': BrokerToJSON(value['broker']),
        'stripePaymentMethodId': value['stripePaymentMethodId'],
        'isReviewingPriorToBookingShipment': value['isReviewingPriorToBookingShipment'],
        'cheapestQuote': QuoteToJSON(value['cheapestQuote']),
        'shipmentState': ShipmentStateToJSON(value['shipmentState']),
        'emergencyContactDetails': EmergencyContactDetailsToJSON(value['emergencyContactDetails']),
        'finalizeBookingStages': value['finalizeBookingStages'],
        'manualQuotingOpen': value['manualQuotingOpen'],
        'manualQuotingNotes': value['manualQuotingNotes'],
        'paymentTermsDays': value['paymentTermsDays'],
        'isBookingSuspended': value['isBookingSuspended'],
        'bookingSuspendedReason': BookingSuspendedReasonToJSON(value['bookingSuspendedReason']),
        'addInsuranceToShipment': value['addInsuranceToShipment'],
        'insuranceAmount': value['insuranceAmount'],
        'insuranceCurrency': CurrencyToJSON(value['insuranceCurrency']),
        'insurancePremiumAmount': value['insurancePremiumAmount'],
        'insurancePremiumCurrency': value['insurancePremiumCurrency'],
        'insurancePremiumTaxesAmount': value['insurancePremiumTaxesAmount'],
        'insurancePremiumReferralReason': value['insurancePremiumReferralReason'],
        'insuranceCommodityGroup': value['insuranceCommodityGroup'],
        'stateOfGoods': StateOfGoodsToJSON(value['stateOfGoods']),
        'branchId': value['branchId'],
        'quotedBy': value['quotedBy'],
        'linearFeet': value['linearFeet'],
        'exclusiveUseNeeded': value['exclusiveUseNeeded'],
        'tarpRequired': value['tarpRequired'],
        'pickupBoothNumber': value['pickupBoothNumber'],
        'deliveryBoothNumber': value['deliveryBoothNumber'],
        'billOfLadingNumber': value['billOfLadingNumber'],
        'pickupLocationHasDock': LoadingCapabilitiesAvailabilityToJSON(value['pickupLocationHasDock']),
        'pickupLocationHasForklift': LoadingCapabilitiesAvailabilityToJSON(value['pickupLocationHasForklift']),
        'deliveryLocationHasDock': LoadingCapabilitiesAvailabilityToJSON(value['deliveryLocationHasDock']),
        'deliveryLocationHasForklift': LoadingCapabilitiesAvailabilityToJSON(value['deliveryLocationHasForklift']),
    };
}

